import React, {useEffect, useRef, useState} from "react";
import {Utils} from "../../../components/audioUtils"
import {path_to_bugs} from "../video_comic_data";
import style from "../styles.module.css";
import {Cursor} from "../../../AssetReferences";

export function RandomVideoBugContainer({shouldDisplayBugs, numberOfBugs, onClick}) {
    const bugs = Array.from({length: numberOfBugs});
    const [displayBugs, setDisplayBugs] = useState(false);

    let displayTimeoutHandler;

    useEffect(() => {
        return () => {
            stopTimeout()
        }
    }, []);

    useEffect(() => {
        if (shouldDisplayBugs) startTimeout();
        else stopTimeout();
    }, [shouldDisplayBugs]);

    function startTimeout() {
        displayTimeoutHandler = setTimeout(
            () => setDisplayBugs(true),
            Utils.getRandomInt(50, 70) * 1000);
            // 2000);
    }

    function stopTimeout() {
        if (displayTimeoutHandler) {
            clearTimeout(displayTimeoutHandler)
        }
        
        setDisplayBugs(false);
    }

    function HandleRandomBugClick() {
        setDisplayBugs(false);
        startTimeout();
        onClick?.();
    }

    return (
        <div className={style.bug_link_container} style={{ opacity: displayBugs ? "100%" : "0%", pointerEvents: displayBugs ? "auto" : "none" }}>            
            { bugs.map((_, index) => <RandomVideoBug key={index} active={displayBugs}  onClick={HandleRandomBugClick}/> )}            
        </div>

    )
}

export function GoBackBug({onClick}) {

    return (
        <div
            style={{
                position: "fixed",
                top: "5%",
                left: "88%"
            }}>
            <BugLink image_default={`${path_to_bugs}/bug11.png`}
                     image_hover={`${path_to_bugs}/bug11_dropshadow.png`}
                     image_alt={"Return to the gallery view"}
                     image_size={200}
                     onClick={onClick}/>
        </div>
    )
}

export function RandomVideoBug({active, onClick}) {
    const pos_min = 10;
    const pos_max = 90;
    const centre_min = 33;
    const centre_max = 67;
    
    const [_active, set_active] = useState(false);
    
    const [position, setPosition] = useState(
        {
            top: GetRandomPosition(true).top,
            left: GetRandomPosition(true).left
        });

    const [bugPath, setBugPath] = useState(GetRandomBugPath());

    let intervalHandler;
    
    useEffect(() => {
        setBugPath(GetRandomBugPath())
    }, []);

    useEffect(() => {        
        if (active) {
            set_active(true);
            intervalHandler = setInterval(() => {
                setPosition({
                    top: GetRandomPosition(true).top,
                    left: GetRandomPosition(true).left
                })
            }, Utils.getRandomFloat(250, 500));
        }
        else {
            clearInterval(intervalHandler);
            setTimeout(() => {
                set_active(false);
                setPosition({
                    top: GetRandomPosition(true).top,
                    left: GetRandomPosition(true).left
                })
            }, 2000) // opacity fade time
        }
    }, [active]);
    

    function GetRandomPosition(avoid_centre = false) {
        function getAvoidingCentre() {
            let value =  Utils.getRandomInt(pos_min, pos_max);
            if (value > centre_min && value < centre_max) {
                if (value > (pos_max - pos_min)) {
                    value = Utils.mapToRange(value, pos_min, pos_max, centre_max, pos_max);
                } else {
                    value = Utils.mapToRange(value, pos_min, pos_max, pos_min, centre_min);
                }
            }
            return value;
        }
        
        return {
            top: `${avoid_centre ? getAvoidingCentre() : Utils.getRandomInt(pos_min, pos_max)}vh`,
            left: `${avoid_centre ? getAvoidingCentre() : Utils.getRandomInt(pos_min, pos_max)}vw`,
        }
    }

    function GetRandomBugPath() {
        // console.log("GetRandomBugPath")
        const bugs = 17;
        return path_to_bugs + "bug" + Utils.getRandomInt(1, bugs);
    }

    return (
        <div
            style={{
                position: "fixed",
                top: position.top,
                left: position.left,
                transition: `top ${Utils.getRandomInt(15, 25)}s, left ${Utils.getRandomInt(15, 25)}s`,
            }}>
            <BugLink
                image_default={`${bugPath}.png`}
                image_hover={`${bugPath}_dropshadow.png`}
                image_alt={"Choose another video"}
                image_size={80}
                onClick={onClick}
            />
        </div>
    );
}

function BugLink({image_default, image_hover, image_alt, image_size, onClick}) {
    const bugRef = useRef(null);
    const [src, setSrc] = useState("")

    function HandleHover(isHovering) {
        setSrc(isHovering ? image_hover : image_default);
    }

    function handleInteractionEvent(e) {
        if (e.type === "click") {
            onClick?.();
        } else if (e.type === "keyup") {
            if (e.key === "Enter" || e.key === " ") {
                onClick?.();
            }
        }
    }

    return (
        <>
            <div className={style.bug_link}
                 ref={bugRef}
            >
                <img
                        className={style.link_image}
                        title={image_alt}
                        alt={image_alt}
                        src={src !== "" ? src : image_default}
                        tabIndex={0}

                        onClick={handleInteractionEvent}
                        onKeyUp={handleInteractionEvent}
                        
                        onFocus={() => HandleHover(true)}
                        onBlur={() => HandleHover(false)}                        
                        onMouseEnter={() => HandleHover(true)}
                        onMouseLeave={() => HandleHover(false)}
                        
                        style={{
                            width: image_size,
                            zIndex: 1,
                            cursor: `url${Cursor.ToiCursorGlow}, pointer`,
                        }}
                    >
                </img>
            </div>
        </>
    )
}
